import { RemovedItem, useCartHook } from '../../hooks/cartHook';
import { testId } from '../../utils';
import { AddBack } from './AddBack';
import { CartCard } from './CartCard';
import { CartDetails, MobileCartDetails } from './CartSummary';
import { VolumeDiscountTable } from './VolumeDiscountTable';
import { Cornerstone } from '@rpi/api';
import React from 'react';

type CartItem =
  | { cartItem: Cornerstone.CheckoutLineItem }
  | { removedItem: RemovedItem };

export const CartWithItems = () => {
  const {
    cart,
    updateItemQuantity,
    removeFromCart,
    deleteLoading,
    clearLoading,
    updateLoading,
    removedItems,
    readdItem,
    dismissRemovedItem,
  } = useCartHook();

  function handleChange(id: number, newQuantity: number) {
    updateItemQuantity(id, newQuantity);
  }

  const removeItem = React.useCallback(
    (item: RemovedItem) => {
      removeFromCart(item);
    },
    [removeFromCart],
  );

  const lineItems = React.useMemo(() => cart?.lineItems ?? [], [cart]);
  const isLoading = updateLoading || deleteLoading || clearLoading;

  const items: CartItem[] = React.useMemo(() => {
    const sortedRemovedItems = removedItems.sort(
      (a, b) => a.itemIndex - b.itemIndex,
    );

    const items: CartItem[] = lineItems.map((item) => ({ cartItem: item }));

    sortedRemovedItems.forEach((removedItem) =>
      items.splice(removedItem.itemIndex, 0, { removedItem }),
    );

    return items;
  }, [lineItems, removedItems]);

  return (
    <div className="flex md:px-0 md:flex-row flex-col gap-4 md:gap-8">
      <div className="flex flex-col gap-8 flex-grow">
        {items.map((item, idx) => {
          if ('cartItem' in item) {
            return (
              <CartCard
                itemIndex={idx}
                key={idx}
                item={item.cartItem}
                handleChange={handleChange}
                removeItem={removeItem}
              />
            );
          } else {
            return (
              <AddBack
                key={idx}
                item={item.removedItem}
                addBack={readdItem}
                dismiss={dismissRemovedItem}
              />
            );
          }
        })}
      </div>

      <div className="hidden md:flex flex-col gap-4">
        <CartDetails isLoading={isLoading} />
        <VolumeDiscountTable {...testId('desktop')} />
      </div>
      <div className="md:hidden flex flex-col gap-4">
        <MobileCartDetails isLoading={isLoading} />
        <VolumeDiscountTable {...testId('mobile')} />
      </div>
    </div>
  );
};
